<template>
  <section id="item">
    <div
      class="bg-red text-white flex justify-between text-left px-3 pt-3 pb-12"
      style="border-radius: 100% 100% 100% 100% / 0% 0% 30% 30%"
    >
      <div>
        <div class="font-semibold text-lg">购物车</div>
        <div class="text-sm">共{{ totalNum }}件商品</div>
      </div>
      <div @click="editingAll">{{ isEditingAll ? "完成" : "编辑" }}</div>
    </div>
    <Loading v-if="loading" size="24px" color="#ee0a24" vertical class="mt-12"
      >加载中...</Loading
    >
    <div v-else>
      <ul class="store_list px-3 -mt-8 pb-6" v-show="totalNum !== 0">
        <!-- 有效的宝贝 -->
        <li
          class="store_item"
          ref="getStoreDOM"
          v-for="(store, storeIndex) in purchaseList"
          :key="store.actId"
        >
          <div
            :class="[
              'store_wrapper',
              store.store_promotion ? '' : 'border_1px_bottom',
            ]"
            style="white-space: nowrap"
          >
            <span class="store_basic pt-3">
              <div
                v-if="
                  store.actState === 'NOT_START' ||
                  store.actState === 'WARMING_UP'
                "
                class="text-xs text-white leading-5 mx-1 bg-green rounded-full"
                style="width: 36px; height: 20px"
              >
                预告
              </div>
              <label
                v-else
                :for="`selectStoreAll_${store.actId}`"
                class="radio_label"
                @change="toggleStore(store.actId)"
              >
                <input
                  type="checkbox"
                  :id="`selectStoreAll_${store.actId}`"
                  class="select_radio"
                  :checked="isStoreSelected(store.actId)"
                />
              </label>

              <div
                class="text-xs text-white leading-5 mx-1"
                style="
                  width: 36px;
                  height: 20px;
                  background: linear-gradient(315deg, #fcdb00 0%, #f78a00 100%);
                  border-radius: 5px;
                "
              >
                活动
              </div>
              <span
                class="overflow-hidden text-sm font-semibold"
                style="text-overflow: ellipsis"
                >{{ store.actName }}</span
              >
              <span
                v-if="store.limitedQuantity"
                class="text-xs ml-3 text-orange-600"
                >限购{{ store.limitedQuantity }}件</span
              ></span
            >
          </div>
          <div
            v-if="store.couponList.length"
            class="store_activity_wrapper justify-between"
          >
            <div class="h-8 -mt-3 flex justify-start items-center">
              <span
                v-for="item in store.couponList"
                :key="item.couponId"
                class="text-xxs text-red border-red1px rounded px-1 mr-1"
                >{{
                  item.threshold
                    ? "满" + item.threshold + "减" + item.faceValue
                    : "减" + item.faceValue
                }}</span
              >
            </div>

            <span
              class="text-red-500 flex items-center text-xxs"
              @click="showGetCoupon(store)"
              >领券
              <Icon
                name="arrow"
                color="red"
                size="10"
                class="font-extrabold float-right flex-shrink-0"
            /></span>
          </div>

          <ul class="purchaseGoodsList">
            <li
              class="commodity_item pb-3"
              v-for="(commodity, commodityIndex) in store.purchaseGoodsList"
              :key="commodity.partGoodsInfoId"
            >
              <SwipeCell
                class="commodity_item_container"
                :id="`commodityItem_${store.actId}_${commodity.partGoodsInfoId}`"
              >
                <div class="flex">
                  <div class="radio_img_wrapper flex items-center pb-6">
                    <div
                      v-if="
                        store.actState === 'NOT_START' ||
                        store.actState === 'WARMING_UP'
                      "
                      class="text-xs text-white leading-5 mx-1 bg-green rounded-full"
                      style="width: 36px; height: 20px"
                    >
                      预告
                    </div>
                    <label
                      v-else
                      :for="`selectStoreOne_${store.actId}_${commodity.partGoodsInfoId}`"
                      class="radio_label"
                      @change="
                        toggleCommodity({
                          partGoodsInfoId: commodity.partGoodsInfoId,
                          purchaseId: commodity.purchaseId,
                          goodsNum: commodity.goodsNum,
                          stock: commodity.stock,
                          actPrice: commodity.actPrice,
                          actId: commodity.actId,
                          partId: commodity.partId,
                          goodsInfoId: commodity.goodsInfoId,
                          goodsId: commodity.goodsId,
                          partGoodsId: commodity.partGoodsId,
                        })
                      "
                    >
                      <input
                        type="checkbox"
                        :id="`selectStoreOne_${store.actId}_${commodity.partGoodsInfoId}`"
                        class="select_radio"
                        style="margin-left: 5px; margin-right: 5px"
                        :checked="
                          isCommoditySelected(commodity.partGoodsInfoId)
                        "
                        :data-cur="`${commodity.partGoodsInfoId}_${commodity.goodsNum}_${commodity.actPrice}`"
                      />
                    </label>
                    <div
                      class="goodsInfoImg overflow-hidden relative rounded-lg"
                      style="height: 84px; width: 84px"
                      @click="
                        $router.push({
                          name: 'CartGoodsDetail',
                          params: { id: commodity.partGoodsId },
                        })
                      "
                    >
                      <img
                        class="w-full h-full"
                        :src="commodity.goodsInfoImg"
                        :alt="commodity.goodsName"
                      />
                      <div
                        v-show="store.actState === 'WARMING_UP'"
                        class="bg-green absolute bottom-0 text-xxs text-white w-full font-normal"
                        style="white-space: nowrap"
                      >
                        {{ dayjs(store.start).format("MM[月]DD[日]") }}开抢
                      </div>
                    </div>
                  </div>

                  <div
                    class="ml-1 flex flex-grow flex-col justify-between"
                    style="min-height: 98px; padding: 0 0 6px 12px"
                  >
                    <div
                      class="flex flex-col flex-grow items-start justify-between pb-1"
                    >
                      <h3 class="commodity_title text-left text-sm">
                        <iframe
                          class="img"
                          v-if="store.activityReward === 'AWARD'"
                          :src="require('@/assets/goodsdetail/抽奖专场.svg')"
                        ></iframe>
                        <iframe
                          class="img"
                          v-if="
                            store.activityReward === 'COMMISSION' &&
                            $store.state.user.distributionFlag
                          "
                          :src="require('@/assets/goodsdetail/双倍佣金.svg')"
                        ></iframe>
                        <iframe
                          class="img"
                          v-if="store.activityReward === 'NEWBIE'"
                          :src="require('@/assets/goodsdetail/新人专场.svg')"
                        ></iframe>

                        {{ commodity.goodsName }}
                      </h3>

                      <p
                        class="sku_picker bg-f8 px-6"
                        v-if="commodity.type_union.length !== 0"
                        @click="handleSkuSelect(commodity)"
                      >
                        {{ commodity.type_union.join(";") }}
                        <img
                          class="ml-1"
                          width="4px"
                          height="6px"
                          style="display: inline-block"
                          src="@/assets/小箭头.svg"
                          alt=""
                        />
                      </p>

                      <div class="flex items-center">
                        <div
                          class="handle_count text-left border border-gray-300 rounded-full flex justify-between items-center"
                        >
                          <Icon
                            class="w-6 flex items-center justify-center"
                            name="minus"
                            @click="
                              reduceCount(
                                storeIndex,
                                commodityIndex,
                                Number(commodity.goodsNum),
                                commodity.partGoodsInfoId,
                                commodity.purchaseId
                              )
                            "
                          />

                          <Field
                            v-model="commodity.goodsNum"
                            type="digit"
                            input-align="center"
                            class="border-l border-r w-12 border-gray-300 h-6 pt-0 px-1"
                            @focus="oldNum = Number(commodity.goodsNum)"
                            @change="
                              (e) => {
                                customChangeNum(
                                  e.target.value,
                                  commodity,
                                  storeIndex,
                                  commodityIndex
                                );
                              }
                            "
                          />
                          <Icon
                            class="w-6 flex items-center justify-center"
                            name="plus"
                            @click="
                              addCount(
                                storeIndex,
                                commodityIndex,
                                Number(commodity.goodsNum),

                                commodity.stock,
                                commodity.partGoodsInfoId,
                                commodity.purchaseId
                              )
                            "
                          />
                        </div>
                        <div
                          v-show="commodity.stock < Number(commodity.goodsNum)"
                          class="text-red text-sm ml-2"
                        >
                          库存{{ commodity.stock }}件
                        </div>
                      </div>
                    </div>
                    <div class="text-red text-left">
                      <span class="text-xs">¥</span>
                      <span class="text-base font-semibold">{{
                        commodity.actPrice.toString().split(".")[0]
                      }}</span>
                      <span
                        class="text-base font-semibold"
                        v-if="
                          commodity.actPrice.toString().split('.').length === 2
                        "
                        >.</span
                      >
                      <span class="text-base font-semibold">{{
                        commodity.actPrice.toString().split(".")[1]
                      }}</span>
                    </div>
                  </div>
                </div>

                <template #right>
                  <div
                    class="delete_commodity h-full text-white flex items-center text-sm px-3"
                    style="background: #ff5500"
                    :id="`delete_${store.actId}_${commodity.partGoodsInfoId}`"
                    @click="
                      deleteCommodity(
                        storeIndex,
                        commodityIndex,
                        commodity.partGoodsInfoId,
                        commodity.purchaseId
                      )
                    "
                  >
                    删除
                  </div>
                </template>
              </SwipeCell>
            </li>
          </ul>
        </li>

        <!-- 失效的宝贝 -->
        <li class="store_item" v-if="invalidGoodsList.length > 0">
          <div class="invaid_title_wrapper">
            <span class="invaid_big_logo">失效宝贝</span>
            <span
              class="remove_invaid_commodity"
              @click="deleteInvaidCommodities()"
              >清空失效宝贝</span
            >
          </div>
          <ul class="purchaseGoodsList">
            <li
              class="commodity_item pb-2"
              v-for="commodity in invalidGoodsList"
              :key="commodity.purchaseId"
            >
              <div class="commodity_item_container invaild_item_container flex">
                <span class="invaid_logo w-12 text-xs ml-1">失效</span>
                <div style="height: 84px; width: 84px" class="flex-shrink-0">
                  <img
                    :src="commodity.goodsInfoImg"
                    :alt="commodity.goodsName"
                    class="goodsInfoImg invalid_img h-full w-full rounded-lg"
                  />
                </div>

                <div
                  class="invaid_detail_wrapper flex flex-col items-start ml-1"
                >
                  <h3 class="commodity_title invaid_title text-sm">
                    {{ commodity.goodsName }}
                  </h3>
                  <p class="invaid_reason">
                    {{
                      commodity.goodsInfoSpecDetails
                        .map((item) => item.detailName)
                        .join(";")
                    }}
                  </p>
                  <p class="text-red font-semibold">
                    ￥{{ commodity.actPrice }}
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </li>
      </ul>

      <!-- no commodities -->
      <NoCommodities v-show="totalNum === 0"></NoCommodities>
    </div>

    <!-- modal -->
    <div class="dialog_wrapper" v-show="showDialog">
      <section class="text-center text-sm">
        <p
          class="top-0 right-0 bottom-0 left-0 p-8 rounded text-white w-64 h-32"
          style="position: fixed; margin: auto; background: rgba(#333333, 0.9)"
          v-if="!isDialog"
        >
          {{ warningMsg }}
        </p>
      </section>
    </div>

    <!-- total -->
    <Total
      :selectListLength="selectListLength"
      :curTotalPrice="curTotalPrice"
      :vaildCommoditiesNum="vaildCommoditiesNum"
      @getSelectAllFeedback="getSelectAllFeedback"
      @getSubmitOrderFeedback="getSubmitOrderFeedback"
      ref="selectAllStatus"
      v-if="totalNum !== 0"
      :isEditingAll="isEditingAll"
    ></Total>
    <ActionSheet v-model="showCoupon" title="优惠券">
      <div class="m-3 overflow-y-auto" style="max-height: 21rem">
        <div
          v-for="item in couponList"
          :key="item.id"
          class="rounded-md border flex flex-row text-white mb-3 items-center justify-between pr-3"
          :style="{
            borderColor:
              item.getstatus !== 'got' && !item.isClaim ? '#E89A52' : '#CECECE',
          }"
        >
          <div
            class="w-40 flex flex-col justify-center items-center p-3"
            :style="{
              background:
                item.getstatus !== 'got' && !item.isClaim
                  ? 'linear-gradient(90deg, #FBC787 0%, #E79950 100%)'
                  : '#CECECE',
            }"
          >
            <div>
              <span class="text-xl">¥&nbsp;</span
              ><span
                class="leading-10 font-semibold"
                style="letter-spacing: 0.1rem; font-size: 2.5rem"
                >{{ item.faceValue }}</span
              >
            </div>
            <div class="text-xs">
              满{{ item.threshold ? item.threshold : "任意" }}元可用
            </div>
          </div>
          <div class="text-left flex-grow ml-3">
            <div class="text-black text-sm mb-1">{{ item.couponName }}</div>
            <div class="text-xs text-gray">
              {{ item.startDate }} - {{ item.endDate }}
            </div>
          </div>
          <div>
            <Button
              :disabled="item.getstatus === 'got' || item.isClaim"
              class="w-20"
              style="padding-left: 12px; padding-right: 12px"
              round
              :color="
                item.getstatus !== 'got' && !item.isClaim
                  ? '#E89A52'
                  : '#CECECE'
              "
              size="mini"
              @click="getCoupon(item)"
              >{{
                item.getstatus !== "got" &&
                !item.isClaim &&
                item.remainNum !== 0
                  ? "立即领取"
                  : item.remainNum === 0
                  ? "已领完"
                  : "已领取"
              }}</Button
            >
          </div>
        </div>
      </div>
      <div class="mx-3 mb-3">
        <Button
          style="padding-left: 12px; padding-right: 12px"
          round
          color="linear-gradient(135deg, #E82237 0%, #FF9D9D 100%)"
          size="large"
          @click="showCoupon = false"
          >完成</Button
        >
      </div>
    </ActionSheet>
    <!-- sku selector -->
    <Sku
      v-model="show"
      :sku="sku"
      :goods="goods"
      :goods-id="goodsId"
      :quota="quota"
      :quota-used="quotaUsed"
      :hide-stock="sku.hide_stock"
      @sku-selected="skuSelected"
      @add-cart="onAddCartClicked"
      ><template #sku-actions="props">
        <div class="van-sku-actions">
          <Button
            square
            size="large"
            type="warning"
            @click="props.skuEventBus.$emit('sku:addCart')"
            style="
              background: linear-gradient(135deg, #e82237 0%, #ff9d9d 100%);
            "
          >
            确定
          </Button>
        </div>
      </template></Sku
    >
  </section>
</template>

<script>
import Total from "./Total.vue";
import NoCommodities from "./NoCommodities.vue";
import {
  Button,
  ActionSheet,
  Sku,
  Icon,
  Field,
  Toast,
  Loading,
  SwipeCell,
} from "vant";
import {
  editSpec,
  editGoodsNum,
  delCartGoods,
  getCoupon,
  batchGetCoupon,
  purchaseInCart,
} from "../webApi";
export default {
  components: {
    Total,
    NoCommodities,
    Button,
    ActionSheet,
    Sku,
    Icon,
    Field,
    Loading,
    SwipeCell,
  },
  props: [
    "purchaseList",
    "invalidGoodsList",
    "vaildCommoditiesNum",
    "totalNum",
    "loading",
  ],

  data() {
    return {
      isEditingAll: false,
      oldNum: null,
      tmall_wuyou_logo:
        "https://gw.alicdn.com/tfs/TB10WFoJH9YBuNjy0FgXXcxcXXa-405-72.png",

      showDialog: false,

      warningMsg: "",

      isDialog: 0,

      selectList: [],

      selectListLength: 0,

      curTotalPrice: 0,

      dialogFeedback: false,

      curStoreIndex: 0,

      curSkuIndex: 0,

      curPartGoodsInfoId: "",
      curPurchaseId: "",
      // ======================领券部分======================
      showCoupon: false,
      couponList: [],
      // ======================领券部分======================
      // =============================================sku部分开始=============================================
      cartBtn: "both",
      goodsId: "",
      quota: 0, //限购数，0 表示不限购
      quotaUsed: 0, //已经购买过的数量
      show: false,
      editingPurchaseId: null,
      editingActId: null,
      sku: {
        // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
        // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。

        tree: [],

        // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
        list: [],
        price: "1.00", // 默认价格（单位元）

        stock_num: 0, // 商品总库存
        collection_id: 2261, // 无规格商品 partGoodsInfoId 取 collection_id，否则取所选 sku 组合对应的 id

        hide_stock: false, // 是否隐藏剩余库存
      },
      goods: {
        // 默认商品 sku 缩略图
        picture: "",
      },

      // =============================================sku部分结束=============================================
    };
  },
  computed: {
    totalPrice() {
      return this.selectList.reduce(
        (val, acc) => acc.goodsNum * acc.actPrice,
        0
      );
    },
  },
  watch: {
    selectList: {
      handler: function () {
        this.selectListLength = this.selectList.map(
          (item) => item.actState !== "NOT_START"
        ).length;
        this.curTotalPrice = 0;
        for (let i = 0, l = this.selectListLength; i < l; i += 1) {
          this.curTotalPrice +=
            this.selectList[i].goodsNum * this.selectList[i].actPrice;
        }
      },
      deep: true,
    },
  },
  methods: {
    // 获取 sku 索引
    getSkuIdIndex(partGoodsInfoId) {
      const result = this.selectList.findIndex(
        (skuItem) => skuItem.partGoodsInfoId === partGoodsInfoId
      );
      return result;
    },

    // 获取所有选中的 partGoodsInfoId 列表
    getAllSelectedSkuId() {
      return this.selectList.map((val) => val.partGoodsInfoId);
    },

    // 判断一个商品是否被选中
    isCommoditySelected(partGoodsInfoId) {
      return this.selectList.find(
        (val) => val.partGoodsInfoId === partGoodsInfoId
      );
    },

    // 获取一个商铺选中的商品 (sku 列表)
    getSelectedSkuIdsByStore(storeId) {
      const currStore = this.getCurrentStore(storeId);

      if (currStore) {
        return currStore.purchaseGoodsList.map((val) => val.partGoodsInfoId);
      }

      return [];
    },

    // 一个商铺是否被选择(点击商铺全选 或者 逐一选中一个商铺的所有商品)
    isStoreSelected(storeId) {
      const skuIds = this.getSelectedSkuIdsByStore(storeId);

      if (skuIds.length > 0) {
        return skuIds.every((partGoodsInfoId) =>
          this.getAllSelectedSkuId().includes(partGoodsInfoId)
        );
      }

      return false;
    },

    // 获取当前商铺
    getCurrentStore(storeId) {
      const currStore = this.purchaseList.find((val) => val.actId === storeId);

      return currStore;
    },

    getMoq(goodsId) {
      for (const store of this.purchaseList) {
        for (const goods of store.purchaseGoodsList) {
          if (goods.goodsId === goodsId) {
            return goods.moq;
          }
        }
      }
      return 1;
    },

    getGoodsName(goodsId) {
      for (const store of this.purchaseList) {
        for (const goods of store.purchaseGoodsList) {
          if (goods.goodsId === goodsId) {
            return goods.goodsName;
          }
        }
      }
      return "";
    },

    // 选择单品
    toggleCommodity(sku) {
      const isCommoditySelected = this.isCommoditySelected(sku.partGoodsInfoId);
      if (isCommoditySelected) {
        this.selectList = this.selectList.filter(
          (val) => val.partGoodsInfoId !== sku.partGoodsInfoId
        );
      } else {
        this.selectList.push(sku);
      }
    },

    // 按商铺批量选择
    toggleStore(storeId) {
      const isStoreSelected = this.isStoreSelected(storeId);
      const currStore = this.getCurrentStore(storeId);

      if (currStore) {
        if (isStoreSelected) {
          const selectedSkuIdsByStore = this.getSelectedSkuIdsByStore(storeId);
          this.selectList = this.selectList.filter(
            (val) => !selectedSkuIdsByStore.includes(val.partGoodsInfoId)
          );
        } else {
          currStore.purchaseGoodsList.forEach((val) => {
            if (!this.isCommoditySelected(val.partGoodsInfoId)) {
              this.selectList.push({
                partGoodsInfoId: val.partGoodsInfoId,
                purchaseId: val.purchaseId,
                actPrice: val.actPrice,
                goodsNum: val.goodsNum,
                stock: val.stock,
                actId: val.actId,
                partId: val.partId,
                goodsInfoId: val.goodsInfoId,
                goodsId: val.goodsId,
                partGoodsId: val.partGoodsId,
              });
            }
          });
        }
      }
    },

    // 增加单品数量
    addCount(
      storeIndex,
      commodityIndex,
      goodsNum,
      stock,
      partGoodsInfoId,
      purchaseId,
      commodity,
      customChange
    ) {
      console.log(
        "storeIndex",
        storeIndex,
        "commodityIndex",
        commodityIndex,
        "goodsNum",
        goodsNum,
        "stock",
        stock,
        "partGoodsInfoId",
        partGoodsInfoId,
        "purchaseId",
        purchaseId
      );
      let diff = goodsNum - this.oldNum;
      if (goodsNum + 1 > stock) {
        this.showDialog = true;
        this.isDialog = 0;
        this.warningMsg = "亲，该宝贝不能购买更多哦～";
        if (commodity) commodity.goodsNum = this.oldNum;

        this.closeDialog();
      } else {
        editGoodsNum({
          purchaseId: purchaseId,
          goodsNum: commodity
            ? Number(
                this.purchaseList[storeIndex].purchaseGoodsList[commodityIndex]
                  .goodsNum
              )
            : Number(
                this.purchaseList[storeIndex].purchaseGoodsList[commodityIndex]
                  .goodsNum
              ) + 1,
        }).then(() => {
          if (!commodity) {
            this.purchaseList[storeIndex].purchaseGoodsList[
              commodityIndex
            ].goodsNum =
              Number(
                this.purchaseList[storeIndex].purchaseGoodsList[commodityIndex]
                  .goodsNum
              ) + 1;
          }

          if (this.getSkuIdIndex(partGoodsInfoId) !== -1) {
            this.selectList[this.getSkuIdIndex(partGoodsInfoId)].goodsNum =
              Number(
                this.selectList[this.getSkuIdIndex(partGoodsInfoId)].goodsNum
              ) + (customChange ? diff : 1);
          }
        });
      }
    },

    // 减少单品数量
    reduceCount(
      storeIndex,
      commodityIndex,
      goodsNum,
      partGoodsInfoId,
      purchaseId,
      commodity,
      customChange
    ) {
      let diff = this.oldNum - goodsNum;
      if ((customChange && goodsNum < 1) || (!customChange && goodsNum < 2)) {
        if (commodity) {
          commodity.goodsNum = 1;
        }

        this.showDialog = true;
        this.isDialog = 0;
        this.warningMsg = "宝贝不能再减少了哦～";
        this.closeDialog();
      } else {
        editGoodsNum({
          purchaseId: purchaseId,
          goodsNum: commodity
            ? this.purchaseList[storeIndex].purchaseGoodsList[commodityIndex]
                .goodsNum
            : this.purchaseList[storeIndex].purchaseGoodsList[commodityIndex]
                .goodsNum - 1,
        }).then(() => {
          if (!commodity) {
            this.purchaseList[storeIndex].purchaseGoodsList[
              commodityIndex
            ].goodsNum -= 1;
          }

          if (this.getSkuIdIndex(partGoodsInfoId) !== -1) {
            this.selectList[this.getSkuIdIndex(partGoodsInfoId)].goodsNum -=
              customChange ? diff : 1;
          }
        });
      }
    },
    customChangeNum(val, commodity, storeIndex, commodityIndex) {
      if (val > this.oldNum) {
        this.addCount(
          storeIndex,
          commodityIndex,
          Number(commodity.goodsNum),

          commodity.stock,
          commodity.partGoodsInfoId,
          commodity.purchaseId,
          commodity,
          true
        );
      } else if (val < this.oldNum) {
        this.reduceCount(
          storeIndex,
          commodityIndex,
          Number(commodity.goodsNum),
          commodity.partGoodsInfoId,
          commodity.purchaseId,
          commodity,
          true
        );
      }
    },

    // 删除无效商品
    deleteInvaidCommodities() {
      this.getDialogFeedback(1, true);
    },

    // 删除单品
    deleteCommodity(
      curStoreIndex,
      curSkuIndex,
      curPartGoodsInfoId,
      purchaseId
    ) {
      this.isDialog = 2;
      this.curStoreIndex = curStoreIndex;
      this.curSkuIndex = curSkuIndex;
      this.curPartGoodsInfoId = curPartGoodsInfoId;
      this.curPurchaseId = purchaseId;
      this.getDialogFeedback(2, true);
    },
    // 获取对话框传递过来的信息（确认删除无效商品 / 确认删除有效商品）
    getDialogFeedback(type, confirmToDelete) {
      if (type === 1) {
        if (confirmToDelete) {
          //批量删除
          delCartGoods({
            purchaseIds: this.invalidGoodsList.map((item) => item.purchaseId),
          }).then((res) => {
            this.selectList = [];
            this.$emit("freshCart");
          });
          // this.invalidGoodsList.splice(0, this.invalidGoodsList.length);
          this.showDialog = false;
        } else {
          this.showDialog = false;
        }
      } else if (confirmToDelete) {
        // 单个删除
        delCartGoods({ purchaseIds: [this.curPurchaseId] }).then(() => {
          this.purchaseList[this.curStoreIndex].purchaseGoodsList.splice(
            this.curSkuIndex,
            1
          );
          if (
            this.purchaseList[this.curStoreIndex].purchaseGoodsList.length === 0
          ) {
            this.purchaseList.splice(this.curStoreIndex, 1);
          }

          this.$emit("handleTotalNum");

          // 在删除一件商品时，如果这件商品已经被选中，那么selectList需要做出变化，相应的总价/总数量也要发生变化
          const result = this.getSkuIdIndex(this.curPartGoodsInfoId);
          if (result !== -1) {
            this.selectList.splice(result, 1);
          }
        });
      }
    },

    handleSkuSelect(commodity) {
      console.log("commodity", commodity);
      this.goods.picture = commodity.goodsInfoImg;
      this.sku.price = commodity.actPrice;
      this.sku.stock_num = commodity.stock;

      this.editingActId = commodity.actId;
      this.editingPurchaseId = commodity.purchaseId;
      let tree = [];
      commodity.goodsSpecs.map((item) => {
        let tempV = [];
        commodity.goodsSpecDetails.map((item2) => {
          if (item2.specId === item.specId) {
            tempV.push({
              id: item2.specDetailId,
              name: item2.detailName,
            });
          }
        });
        tree.push({
          k: item.specName,
          k_id: item.specId,
          v: tempV,
          k_s: item.specName,
        });
      });
      console.log("tree!", tree);

      let list = [];
      commodity.goodsInfoList.map((item) => {
        let temp = {
          id: item.partGoodsInfoId,
          price: item.actPrice * 100,
          stock_num: item.stock,
        };
        item.goodsInfoSpecDetails.map((item2) => {
          temp[item2.specName] = item2.specDetailId;
        });
        list.push(temp);
      });
      console.log("list", list);
      this.sku.tree = tree;
      this.sku.list = list;
      this.show = true;
    },
    skuSelected(skuValue) {
      if (skuValue.selectedSkuComb) {
        this.purchaseList.map((act) => {
          if (this.editingActId === act.actId) {
            act.purchaseGoodsList.map((item) => {
              if (this.editingPurchaseId === item.purchaseId) {
                item.goodsInfoList.map((sku) => {
                  if (skuValue.selectedSkuComb.id === sku.partGoodsInfoId) {
                    this.goods.picture = sku.goodsInfoImg;
                  }
                  return;
                });
                return;
              }
            });
            return;
          }
        });
      } else {
        this.purchaseList.map((act) => {
          if (this.editingActId === act.actId) {
            act.purchaseGoodsList.map((item) => {
              if (this.editingPurchaseId === item.purchaseId) {
                this.goods.picture = item.goodsInfoImg;
                return;
              }
            });
            return;
          }
        });
      }
    },
    onAddCartClicked(e) {
      console.log("e", e);
      console.log("this.editingPurchaseId", this.editingPurchaseId);
      console.log(this);
      let tempChange = null;
      let tempDel = null;
      this.purchaseList.forEach((item) => {
        if (this.editingActId === item.actId) {
          item.purchaseGoodsList.forEach((item2) => {
            if (e.selectedSkuComb.id === item2.partGoodsInfoId) {
              tempChange = {
                purchaseId: item2.purchaseId,
                partGoodsInfoId: item2.partGoodsInfoId,
                goodsNum: Number(item2.goodsNum) + e.selectedNum,
              };
            } else if (this.editingPurchaseId === item2.purchaseId) {
              tempDel = this.editingPurchaseId;
            }
          });
          return;
        }
      });
      if (!tempChange) {
        tempChange = {
          goodsNum: e.selectedNum,
          purchaseId: this.editingPurchaseId,
          partGoodsInfoId: e.selectedSkuComb.id,
        };
      }
      if (tempDel === tempChange.purchaseId) {
        tempDel = null;
      }
      console.log("tempChange", tempChange);
      console.log("tempDel", tempDel);

      const fresh = () => {
        this.show = false;
        this.editingPurchaseId = null;
        this.$emit("freshCart");
        this.selectList = [];
      };
      if (tempDel) {
        delCartGoods({ purchaseIds: [tempDel] }).then((res) => {
          fresh();
        });
      } else {
        editSpec(tempChange).then((res) => {
          fresh();
        });
      }
    },

    // 获取提交订单的反馈
    getSubmitOrderFeedback() {
      if (this.selectList.length === 0) {
        this.showDialog = true;
        this.isDialog = 0;
        this.warningMsg = "您还没有选择宝贝哦～";
        this.closeDialog();
      } else {
        console.log("isEditingAll", this.isEditingAll);

        if (this.isEditingAll) {
          //批量删除
          delCartGoods({
            purchaseIds: this.selectList.map((item) => item.purchaseId),
          }).then((res) => {
            this.selectList = [];
            this.$emit("freshCart");
          });
        } else {
          // 下单
          var grouped = Object.groupBy(
            this.selectList,
            ({ goodsId }) => goodsId
          );
          for (let goodsId in grouped) {
            let moq = this.getMoq(goodsId);
            let gnm = this.getGoodsName(goodsId);
            let num = grouped[goodsId].reduce((a, b) => a + b.goodsNum, 0);
            if (num < moq) {
              Toast({
                message: `${gnm}起订数量为${moq}件`,
                position: "center",
                duration: 1000,
              });
              return;
            }
          }
          if (
            this.selectList.some((item) => item.stock < Number(item.goodsNum))
          ) {
            Toast({
              message: "库存不足",
              position: "center",
              duration: 1000,
            });
            return;
          }
          console.log("this.selectList", this.selectList);
          let autoGetCouponIds = [];
          this.purchaseList.map((item) => {
            item.couponList.map((item2) => {
              if (
                item2.getstatus !== "got" &&
                !item2.isClaim &&
                item2.remainNum !== 0
              ) {
                autoGetCouponIds.push(item2.couponId);
              }
            });
          });
          console.log("autoGetCouponIds", autoGetCouponIds);
          batchGetCoupon(autoGetCouponIds)
            .then((res) => {
              Toast({
                message: "已自动为您领取优惠券",
                position: "center",
                duration: 1000,
              });
            })
            .finally(() => {
              let sub = {
                suite: false,
                orderGroups: [],
                purchaseIds: [],
              };
              let temp = {};
              this.selectList.map((item) => {
                sub.purchaseIds.push(item.purchaseId);
                if (temp[item.actId]) {
                  if (temp[item.actId][item.partId]) {
                    temp[item.actId][item.partId].push({
                      actSkuId: item.partGoodsInfoId,
                      actSpuId: item.partGoodsId,
                      skuId: item.goodsInfoId,
                      spuId: item.goodsId,
                      qty: item.goodsNum,
                    });
                  } else {
                    temp[item.actId][item.partId] = [
                      {
                        actSkuId: item.partGoodsInfoId,
                        actSpuId: item.partGoodsId,
                        skuId: item.goodsInfoId,
                        spuId: item.goodsId,
                        qty: item.goodsNum,
                      },
                    ];
                  }
                } else {
                  temp[item.actId] = {};
                  temp[item.actId][item.partId] = [
                    {
                      actSkuId: item.partGoodsInfoId,
                      actSpuId: item.partGoodsId,
                      skuId: item.goodsInfoId,
                      spuId: item.goodsId,
                      qty: item.goodsNum,
                    },
                  ];
                }
              });
              console.log("temp", temp);

              for (const key in temp) {
                let te = { actId: key };
                this.purchaseList.map((iii) => {
                  if (iii.actId === key) {
                    te.actName = iii.actName;
                    te.limitedQuantity = iii.limitedQuantity;
                    return;
                  }
                });
                let orders = [];
                for (const key2 in temp[key]) {
                  orders.push({
                    partId: key2,
                    items: temp[key][key2],
                  });
                }
                te.orders = orders;
                sub.orderGroups.push(te);
              }
              console.log("sub", sub);
              purchaseInCart(sub).then(({ data }) => {
                this.$router.push({
                  name: "Settle",
                  params: {
                    fid: data,
                  },
                });
              });
            });
        }
      }
    },

    // 定时关闭对话框
    closeDialog() {
      setTimeout(() => {
        this.showDialog = false;
      }, 1000);
    },

    getSelectAllFeedback() {
      if (this.selectListLength === this.vaildCommoditiesNum) {
        this.selectList = [];
      } else {
        this.purchaseList.forEach((store) => {
          if (
            store.actState !== "NOT_START" &&
            store.actState !== "WARMING_UP"
          ) {
            store.purchaseGoodsList.forEach((commodity) => {
              if (!this.isCommoditySelected(commodity.partGoodsInfoId)) {
                this.selectList.push({
                  goodsNum: commodity.goodsNum,
                  stock: commodity.stock,
                  partGoodsInfoId: commodity.partGoodsInfoId,
                  purchaseId: commodity.purchaseId,
                  actPrice: commodity.actPrice,
                  actId: commodity.actId,
                  partId: commodity.partId,
                  goodsInfoId: commodity.goodsInfoId,
                  goodsId: commodity.goodsId,
                  partGoodsId: commodity.partGoodsId,
                });
              }
            });
          }
        });
      }
    },
    editingAll() {
      this.isEditingAll = !this.isEditingAll;
    },

    getCoupon(item) {
      getCoupon(item.couponId).then((res) => {
        Toast({
          message: res.message,
          position: "center",
          duration: 1000,
        });
        this.$set(item, "getstatus", "got");
      });
    },
    showGetCoupon(store) {
      this.showCoupon = true;
      this.couponList = store.couponList;
    },
  },
};
</script>

<style lang="less" slot-scope>
#item {
  position: relative;
  width: 100%;
  padding-bottom: calc(env(safe-area-inset-bottom) + 42px);
}

.store_list {
  margin-bottom: 100px;
  padding-top: 12px;
  .store_item {
    padding: 2px;
    box-shadow: 0rem 0.04rem 0.12rem 0rem rgb(153 153 153 / 30%);
    border-radius: 20px;
    margin-top: 12px;
    background: #ffffff;
    &:first-child {
      margin-top: 0;
    }
  }
}

.store_wrapper {
  display: flex;
  align-items: center;
  padding: 2px 10px;
  .store_basic {
    display: flex;
    align-items: center;

    width: 90%;
  }
}

.store_activity_wrapper {
  display: flex;

  margin: 12px 50px;
}

.commodity_item {
  position: relative;
  overflow: hidden;
}

.commodity_title {
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  .img {
    display: inline-block;
    height: 30px;
    width: 104px;
  }
}

.invaid_title_wrapper {
  display: flex;
  justify-content: space-between;
  padding: 16px 10px 0 48px;
  font-size: 14px;
  .remove_invaid_commodity {
    color: #ff5500;
    border: 1px solid #ff5500;
    border-radius: 4px;
    padding: 6px;
  }
}

.invaild_item_container {
  align-items: center;
}

.invaid_logo {
  background: #aaaaaa;
  color: #ffffff;
  border-radius: 9999px;
  text-align: center;
}

.invalid_img {
  margin-left: 8px !important;
}

.invaid_detail_wrapper {
  width: 602px;
  padding: 6px 0 6px 12px;
}

.invaid_title {
  color: #999999;
}

.invaid_reason {
  margin: 8px 0;
}

input[type="checkbox"] {
  width: 40px;
  height: 40px;
  background-color: #fff;
  -webkit-appearance: none;
  border: 1px solid #c9c9c9;
  border-radius: 50%;
  outline: none;
}

.radio_label input[type="checkbox"]:checked {
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAZdEVYdFNvZnR3YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAADg2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDggNzkuMTY0MDM2LCAyMDE5LzA4LzEzLTAxOjA2OjU3ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1wTU06T3JpZ2luYWxEb2N1bWVudElEPSJ4bXAuZGlkOjk3YTFlYWU3LWRkNWItNDY3MS1iOWViLWYyYWE3OTI4OTNkZCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDozMzFGODFBRDg2MzQxMUVCOEUxMUIxRENDMkI4MzBBOCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDozMzFGODFBQzg2MzQxMUVCOEUxMUIxRENDMkI4MzBBOCIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgMjEuMCAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOmYyNjVjZmNiLWY4MGUtNGVhYi04MDc5LThjM2VkMGUwOWExYSIgc3RSZWY6ZG9jdW1lbnRJRD0iYWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOjA3MDJkZTNiLWQ1YTQtMGQ0Yy1hYjExLTBhNDgzYWM1NjIyMSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PjRoKN0AAABMSURBVDhPY/wPBAxkACYoTTIgWyNWp76TVYWyIEDo8W0oCwEwbETXBALYxFA0YlMAA+hy9A8c6mjEFnowgC6HYSM2zdjEhkySY2AAAOFTGw6epviMAAAAAElFTkSuQmCC")
    no-repeat center;
}
</style>
